<template>
  <div>
    <el-upload ref="upload" accept="image/*" v-if="!disabled && (!limit || fileList.length < limit)" :headers="headers" :action="action" :multiple="false"
      :file-list="fileList" :before-upload="beforeUpload" :on-success="successUpload" :show-file-list="false"
      :on-progress="progressUpload" :on-error="errorUpload" :limit="limit" v-bind="$attrs">
      <slot v-bind:fileList="fileList">
        <div class="picture_upload flex-center-center">
          <i class="el-icon-plus"></i>
        </div>
      </slot>
      <slot name="tip"></slot>
    </el-upload>
    <transition-group name="fade" tag="div" class="transition_container" v-if="showFileList">
        <div class="picture_box" v-for="(item, index) in fileList" :key="index">
          <el-image ref="elImage" :src="item.url" :preview-src-list="previewSrcList" v-if="item.url"></el-image>
          <el-avatar shape="square" :size="100" v-else>上传中</el-avatar>
          <div class="picture_box_action flex-center-center" v-if="item.status == 'success' && !disabled">
              <i class="el-icon-zoom-in icon" @click="handlePreview(item)"></i>
              <i class="el-icon-delete icon" @click="handleRemove(item, index)"></i>
          </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
export default {
    name: 'UploadImg',
  props: {
    value: {  //默认上传列表
      type: [Array, String],
      default: () => { return [] }
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxSize: { // 文件大小限制
      type: Number,
      default: 10
    },
    limit: Number, // 限制上传文件数量
    imgWidth: Number, // 限制图片宽度
    imgHeight: Number, // 限制图片高度
    showFileList: { // 是否显示文件列表
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      headers: {
        Authorization: 'Bearer ' + getToken()
      },
      action: process.env.VUE_APP_FILE_UPLOAD_URL, // 上传的图片服务器地址

      fileList: [],
      previewSrcList: [],
      onlinePreview: false,
      onlinePreviewSrc: null,
      onlinePreviewName: null,
      onlinePreviewSuffix: null
    }
  },
  watch: {
    value: {
      handler (newArr) {
        if(!newArr || !newArr.length) {
            this.fileList = [];
        }
        if (typeof newArr == 'string' && newArr.includes('[' && ']')) {
          newArr = JSON.parse(newArr);
          this.$emit('input', newArr)
        }

        this.previewSrcList = [];
        if (newArr && this.fileList.length == 0) {
          this.fileList = newArr.map(item => {
            return {
              status: 'success',
              url: (() => {
                this.previewSrcList.push(item);
                return item;
              })()
            }
          })
        } else if (newArr && this.fileList.length > 0) {
          newArr.map(item => {
            this.previewSrcList.push(item);
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    clearFileList() {
      this.fileList = [];
    },
    validate () {
      if (this.value.length === this.fileList.length) return true;
      else {
        const h = this.$createElement;
        this.$notify({
          title: '操作失败',
          type: 'error',
          duration: 5000,
          message: h('div', { style: 'color: teal' }, '正在上传文件,请等待文件上传完成后再操作！')
        });
        return false
      }
    },
    async handlePreview (item) {
      this.previewSrcList.map((i, index) => {
        if (item.url == i) {
          this.$refs.elImage[index].clickHandler()
        }
      })
    },
    handleRemove (file, index) {
      this.fileList.splice(index, 1);
      this.$emit('input', this.value.filter(item => item !== file.url));
    },
    async beforeUpload (file) {
      return new Promise((resolve, reject) => {
        if (this.maxSize < file.size / 1024 / 1024) {
          const h = this.$createElement;
          this.$notify({
            title: '上传失败',
            type: 'error',
            duration: 3000,
            message: h('div', { style: 'color: teal' }, '上传的附件不能超过' + this.maxSize + 'M')
          });
          reject(false);
        }else if (this.imgWidth && this.imgHeight) {
          const img = new Image();
          img.onload = async () => {
            if(img.width !== this.imgWidth || img.height !== this.imgHeight) {
              const h = this.$createElement;
              this.$notify({
                title: '上传失败',
                type: 'error',
                duration: 3000,
                message: h('div', { style: 'color: teal' }, '上传的图片尺寸须为' + this.imgWidth + '*' + this.imgHeight)
              });
              reject(false);
            }else {
              resolve(true);
            }
          };
          img.src = URL.createObjectURL(file);
        }else {
          resolve(true);
        }
      })
    },
    progressUpload (e, file) {
      if (file && this.fileList.filter(i => i.uid === file.uid).length == 0) this.fileList.push(file);
    },
    errorUpload (err, file) {
      const h = this.$createElement;
      this.$notify({
        title: '上传失败',
        type: 'error',
        duration: 5000,
        message: h('div', { style: 'color: teal' }, '服务器内部错误，请重试！')
      });
      this.fileList = this.fileList.filter(i => i.uid !== file.uid);
    },
    successUpload (res, file, fileList) {
      this.fileList = fileList.map(item => {
        return {
          ...item,
          url: (() => {
            if (item.status !== 'success') return null;
            else return item.accessUrl ?? item.response.data.url;
          })()
        }
      });
      this.$emit('input', fileList.reduce((pre, cur) => {
        if (cur.status == 'success') {
          pre.push(cur.accessUrl ?? cur.response.data.url);
        }
        return pre;
      }, []));
    },
  },
}
</script>

<style scoped lang="scss">
.fade-enter-active {
  transform: translateY(0px);
  opacity: 1;
  transition: all 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.transition_container {
  overflow: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.file_box {
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: 10px;
  margin-right: 10px;
  padding: 10px;
  height: 92px;
  display: flex;
  align-items: center;
  position: relative;
  width: calc(100% / 3 - 10px);
  min-width: 350px;

  &:nth-last-of-type(1) {
    margin-bottom: 10px;
  }

  .file_name {
    flex: 1;
    text-align: left;
    color: #606266;
    overflow: hidden;
    padding-left: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color .3s;
    cursor: pointer;

    &:hover {
      color: #409eff;
    }
  }

  .success_status {
    position: absolute;
    right: 0;
    top: 0px;
    text-align: center;
    border-top-right-radius: 5px;
    width: 32px;
    height: 32px;
    line-height: 32px;
    overflow: hidden;

    // &::after {
    //     content: '';
    //     position: absolute;
    //     top: -24px;
    //     right: -24px;
    //     width: 0;
    //     height: 0;
    //     border-top: 23px solid transparent;
    //     border-right: 23px solid transparent;
    //     border-bottom: 23px solid #13ce66;
    //     border-left: 23px solid transparent;
    //     box-shadow: 0 1px 1px #ccc;
    //     transform: rotate(45deg);
    // }
    .el-icon-check {
      color: #fff;
      font-size: 14px;
      position: absolute;
      z-index: 999;
      top: 3px;
      right: 1px;
      display: block;
    }

    .el-icon-close {
      font-size: 18px;
      font-weight: bold;
      position: absolute;
      z-index: 999;
      top: 5px;
      right: 5px;
      color: red;
      // display: none;
      cursor: pointer;
      opacity: 1;
    }
  }
}
.picture_upload {
  border-radius: 4px;
  width: 100px;
  height: 100px;
  overflow: hidden;
  position: relative;
  margin-right: 10px;
  border: 1px dashed rgb(192, 204, 218);
  .el-icon-plus {
    font-size: 28px;
    color: rgb(140, 147, 157);
  }
}
.picture_box {
    border-radius: 4px;
    width: 100px;
    height: 100px;
    overflow: hidden;
    position: relative;
    margin-right: 10px;
    margin-top: 10px;
    border: 1px solid rgb(192, 204, 218);
    &:last-child {
        margin-right: 0;
    }
    &:hover {
        .picture_box_action {
            display: flex;
        }
    }
    .picture_box_action {
        display: none;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0,0,0,0.6);
        .icon{
            color: #fff;
            font-size: 18px;
            cursor: pointer;
            margin-right: 10px;
            &:last-child {
                margin-right: 0;
            }
        }
    }
}

.text_box {
    line-height: 26px;
    width: 100%;
    &:first-child {
        margin-top: 5px;
    }
    .percentage {
        margin-left: 8px;
        color: rgb(96, 98, 102);
    }
    .el-icon-close {
        margin-left: 8px;
        cursor: pointer;
        font-size: 16px;
        color: rgb(96, 98, 102);
        &:hover {
            color: #F56C6C;
        }
    }
}
</style>